import { createContext, useContext } from "react";

const JournalNameContext = createContext(null);

export const useJournalName = () => {
  const ctx = useContext(JournalNameContext);
  return ctx || { journalName: "ihkeely", openRenameModal: () => {} };
};

export const JournalNameProvider = JournalNameContext.Provider;
